import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../data-access/authentication-service/authentication.service';

/**
 * Guard that checks for a valid authentication token.
 * If no valid token exists, redirects to /auth/login with the current URL as redirectUrl.
 */
export const isAuthenticatedGuard: CanActivateFn = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router = inject(Router);
    const authentication = inject(AuthenticationService);

    if (!authentication.hasValidToken()) {
        if (!authentication.tokenIsVerified()) {
            const redirectUrl = encodeURIComponent(state.url);
            router.navigate(['/auth/login'], { queryParams: { redirectUrl } });
            return false;
        }
    }

    return true;
};
